var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgTwitter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.375 4.2886C18.6963 4.62689 17.9327 4.79603 17.1691 4.8806C17.9327 4.37317 18.5266 3.61203 18.8659 2.76632C18.1024 3.18917 17.254 3.52746 16.4055 3.69661C14.9632 2.17432 12.5028 2.08975 10.9757 3.52747C9.95759 4.45775 9.53336 5.8109 9.87273 7.16404C6.81843 6.9949 3.93383 5.55717 1.98247 3.18917C0.964372 4.96517 1.47342 7.16403 3.17025 8.26346C2.57636 8.26346 1.98246 8.09432 1.38857 7.75604C1.38857 7.75604 1.38857 7.75603 1.38857 7.8406C1.38857 9.70117 2.6612 11.2235 4.44287 11.5617C3.84898 11.7309 3.25509 11.7309 2.74604 11.6463C3.25509 13.1686 4.69741 14.268 6.3094 14.268C4.95193 15.3675 3.25509 15.8749 1.55826 15.8749C1.2189 15.8749 0.964366 15.8749 0.625 15.7903C5.7155 19.004 12.418 17.5663 15.642 12.492C16.7449 10.716 17.3388 8.68632 17.3388 6.65661C17.3388 6.48746 17.3388 6.31831 17.3388 6.14917C18.1872 5.72631 18.8659 5.04975 19.375 4.2886Z",
    fill: "#A1A8B3"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/twitter.c7d3b016cf72a29481da1d91c87f2497.svg";
export { ForwardRef as ReactComponent };